// ============================================================
// src/config/produtoDaUrl.js
// O mesmo app serve dois produtos; o endereço aberto decide o nome.
// integraientregas.* → IntegrAI Entregas; qualquer outro → IntegrAI CRM
// ============================================================

const PRODUTOS_URL = {
  entregas: {
    nome:   'IntegrAI Entregas',
    sufixo: 'Entregas',
    slogan: 'Pedidos, entregadores e rastreio num lugar só',
  },
  crm: {
    nome:   'IntegrAI CRM',
    sufixo: 'CRM',
    slogan: 'Atendimento, vendas e recompra num lugar só',
  },
};

export function produtoDaUrl(hostname = window.location.hostname) {
  return hostname.includes('integraientregas') ? PRODUTOS_URL.entregas : PRODUTOS_URL.crm;
}
